import { Action, createAction, handleActions } from "redux-actions";
import { SnackbarVariant } from "./SnackBarContent";

export interface SnackbarMessage {
  text: string;
  variant: SnackbarVariant;
  key: number;
}

export interface SnackbarState {
  queue: SnackbarMessage[];
  currentMessage: SnackbarMessage | null;
  variant: SnackbarVariant;
}

/**
 * La variante es opcional y por defecto es "error". Los tipos de redux-actions
 * no expresan argumentos opcionales cuando hay metaCreator, así que el creator
 * se declara con su firma real.
 */
const queueMessage = createAction(
  "SNACKBAR_QUEUE_MESSAGE",
  (text: string, variant: SnackbarVariant = "error"): SnackbarMessage => ({
    text,
    variant: variant,
    key: new Date().getTime(),
  }),
  () => ({ doNotSendToAnalytics: true })
) as unknown as (
  text: string,
  variant?: SnackbarVariant
) => Action<SnackbarMessage>;

const closeMessage = createAction(
  "SNACKBAR_CLOSE_MESSAGE",
  () => {},
  () => ({ doNotSendToAnalytics: true })
);

const processQueue = createAction(
  "SNACKBAR_PROCESS_QUEUE",
  () => {},
  () => ({ doNotSendToAnalytics: true })
);

const initialState: SnackbarState = {
  queue: [],
  currentMessage: null,
  variant: "error",
};

const snackbarReducer = handleActions<SnackbarState, any>(
  {
    [queueMessage.toString()]: (
      state: SnackbarState,
      action: Action<SnackbarMessage>
    ): SnackbarState => {
      return {
        ...state,
        currentMessage: state.currentMessage ? null : action.payload,
        variant: action.payload.variant,
        queue: state.currentMessage
          ? [...state.queue, action.payload]
          : [...state.queue],
      };
    },
    [closeMessage.toString()]: (state: SnackbarState): SnackbarState => {
      return {
        ...state,
        currentMessage: null,
      };
    },
    [processQueue.toString()]: (state: SnackbarState): SnackbarState => {
      if (state.queue.length > 0) {
        const newQueue = state.queue.slice();
        const message = newQueue.shift() as SnackbarMessage;

        return {
          ...state,
          queue: newQueue,
          currentMessage: message,
        };
      } else {
        return {
          ...state,
          currentMessage: null,
        };
      }
    },
  },
  initialState
);

export { snackbarReducer };
export { queueMessage, processQueue, closeMessage };
